const algoliaDashFilters = {
  'attributes_translated.POLARIZED': {
    icon: 'polarized',
    count: 'POLARIZED',
    sortFlag: 'polarized',
  },
  'attributes_translated.LIMITED_EDITION': {
    icon: 'limited_edition',
    count: 'TRUE',
    sortFlag: 'limited_edition',
  },
  'attributes_translated.SALE': {
    icon: 'sale',
    count: 'TRUE',
    sortFlag: 'sale',
  },
  'attributes_translated.FRAME_SHAPE_FACET?Pilot': {
    icon: 'pilot',
    count: 'Pilot',
    sortFlag: 'pilot_frame_shape',
  },
  'attributes_translated.CHANNEL_DETAILS?ONLINE ONLY': {
    icon: 'online-only',
    count: 'ONLINE ONLY',
    sortFlag: 'online_only',
  },
  'attributes_translated.CHANNEL_DETAILS?EXCLUSIVE SGH': {
    icon: 'exclusive',
    count: 'EXCLUSIVE SGH',
    sortFlag: 'exclusive',
  },
  'attributes_translated.CUSTOMIZABLE': {
    icon: 'make_it_yours',
    count: 'TRUE',
    sortFlag: 'customizable',
  },
  'attributes_translated.ENGRAVABLE': {
    icon: 'engraving',
    count: 'TRUE',
    sortFlag: 'engravable',
  },
  'attributes_translated.RX_FILTER': {
    icon: 'prescription',
    count: 'TRUE',
    sortFlag: 'roxable',
  },
}
export default algoliaDashFilters
